import React from 'react'

function BlogFooterContainer({ containerObject, templateName, contentId, dataZone }) {


    const blogFooterStyle = {
        color: '#ffffff',
        display: 'flex',
        height: '64px',
        backgroundColor: '#35649a ',
    }
    
   const blogFooterList= {
        display: 'flex',
        margin: '0',
    }

    const additionStyle = {
        display: 'flex',
        alignItems: 'center'
    }

    return (
        <>
            <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId}
                data-template-name={templateName} className="vast-plugin-content row gx-0">

                <div style={blogFooterStyle} aria-label="WordPress.com">
                    <ul style={blogFooterList}>
                        <li className="blog-logo" style={additionStyle}> 
                            Powered By Vast Blog
                            {/* <a role="menuitem" className="blog-link" href="#">
                                <img style={{ cursor: "pointer" }} className="login-logo-img" src="/cmsadminui/static-assets/VastLogo.png" />
                                <h5 className='cxm-header-logo'>BLOG</h5>
                            </a> */}
                        </li>
                    </ul>
                </div>
            </div>
        </>
    )
}

export default BlogFooterContainer
